// extracted by mini-css-extract-plugin
export default {"containerSegment":"ContainerSegment_containerSegment__+Y9mR"};